import React, { useEffect, useRef, useState } from 'react';
import { Alert, Button, Card, Col, Form, Modal, Row, Spinner } from "react-bootstrap";
import MyApiClient from '../../../../api-client/MyApiClient';
import { useNavigate } from 'react-router-dom';
import Select from "react-select";
import { sidSelectStyles } from "../../Util/sidSelectStyles";
import { italianProvinces, fiscalRegime, haRegimeOrdinario } from "../../../components/Util/enum";

import { conMotivo } from "../../Util/erroreServer";
import { segnalaMancanti } from "../../Util/campiMancanti";
const optionsLegge398 = [
    { value: true, label: "Si" },
    { value: false, label: "No" },
];

export const FormFatturazione = (props) => {

	const formRef = useRef(null);
	const navigate = useNavigate();
	// Dopo l'invio o il salvataggio si resta nel tab «Documenti fiscali» de «La mia struttura»: si ricarica l'indirizzo con ?tab=fatturazione
	// (senza, il ricaricamento riporterebbe al primo tab o, a seconda da dove si è arrivati, fuori dalla scheda)
	const ricaricaQui = () => {
		if (!props.isSuperAdmin) window.history.replaceState(window.history.state, '', '/struttura/lamiastruttura?tab=fatturazione');
		navigate(0);
	};

	const [billingEnabled, setBillingEnabled] = useState(false);
	const [invoiceStatus, setInvoiceStatus] = useState('');
	const [formData, setFormData] = useState({
		ragione_sociale: '',
		partita_iva: '',
		fiscal_regime: '',
		vat_section: '',
		codice_fiscale: '',
		pec: '',
		indirizzo: '',
		cap: '',
		citta: '',
		provincia: '',
		nazione: 'Italia',
        legge_398_91: null
	});
	const [loadingShowed, setLoadingShowed] = useState(false);
	const [modalShowed, setModalShowed] = useState(false);
	const [reloadOnClose, setReloadOnClose] = useState(false);
	const [showConfirmModal, setShowConfirmModal] = useState(false);
    const [pendingStatus, setPendingStatus] = useState(null);
	const [modalTitle, setModalTitle] = useState('');
	const [modalText, setModalText] = useState('');
    const [rejectionMessageInput, setRejectionMessageInput] = useState('');
    const [receivedRejectionMessage, setReceivedRejectionMessage] = useState('');
    const [showSaveConfirmModal, setShowSaveConfirmModal] = useState(false);

	const handleSelectChange = (selectedOption, name) => {
        const selectedValue = Array.isArray(selectedOption)
            ? selectedOption.map(option => option.value)
            : selectedOption?.value || '';
    
        setFormData(prev => ({
            ...prev,
            [name]: selectedValue,
        }));
    };

    const handleSelectLegge398 = (selectedOption) => {
        setFormData(prevState => ({
            ...prevState,
            legge_398_91: selectedOption.value
        }));
    };

    const handleSwitchChange = (e) => {
        const isChecked = e.target.checked;
        const initialEnabled = props.profile?.club?.invoiceDataSender?.invoice_enabled;

        if (!isChecked && initialEnabled) {
            setShowConfirmModal(true);
        } else {
            setBillingEnabled(isChecked);
        }
    };

    const performSave = async (isEnabled) => {
        try {
            const tokenDetailsString = sessionStorage.getItem('userDetails');
            if (tokenDetailsString) {
                const tokenDetails = JSON.parse(tokenDetailsString);
                const token = tokenDetails.idToken;
                const apiClient = new MyApiClient();

                let data_update = {};
                if(isEnabled) {
                    data_update = {
                        club: {
                            id: props.profile.club.id,
                            invoiceDataSender: {
                                invoice_enabled: true,
                                country_code: 'IT',
                                vat_number: formData.partita_iva,
                                tax_code: formData.codice_fiscale,
                                denomination: formData.ragione_sociale,
                                pec: formData.pec,
                                address: formData.indirizzo,
                                zip_code: formData.cap,
                                city: formData.citta,
                                province: formData.provincia,
                                nation: 'IT',
                                fiscal_regime: haRegimeOrdinario(props.profile.club.clubNature) ? 'RF01' : formData.fiscal_regime,
                                vat_section: formData.vat_section
                            }
                        } 
                    };

                    if (props.profile.club.clubNature === 'ASD' || props.profile.club.clubNature === 'SSD') {
                        data_update.club.legge_398_91 = formData.legge_398_91;
                    } else {
                        data_update.club.legge_398_91 = false;
                    }

                } else {
                    data_update = {
                        club: {
                            id: props.profile.club.id,
                            invoiceDataSender: {
                                invoice_enabled: false,
                                vat_number: '',
                                tax_code: '',
                                denomination: '',
                                pec: '',
                                address: '',
                                zip_code: '',
                                city: '',
                                province: '',
                                fiscal_regime: 'RF01',
                                vat_section: '',
                                status: null,
                                rejectionMessage: null
                            },
                            legge_398_91: null
                        } 
                    };
                }

                setLoadingShowed(true);
                const saveResult = await apiClient.updateProfile(token, data_update);
                setLoadingShowed(false);

                if (saveResult && saveResult.error) {
                    setModalTitle("Errore durante l'operazione");
                    setModalText("Si è verificato un errore durante il salvataggio (" + saveResult.error + ")");
                    setReloadOnClose(false);
                    setModalShowed(true);
                } else {
                    setModalTitle("Operazione completata");
                    setModalText("Salvataggio avvenuto con successo.");
                    setReloadOnClose(true);
                    setModalShowed(true);
                }
            } else {
                setModalTitle("Errore durante l'operazione");
                setModalText(conMotivo("Si è verificato un errore durante il salvataggio."));
                setReloadOnClose(false);
                setModalShowed(true);
            }
        } catch (error) {
            console.error("Error fetching data:", error);
        }
    };

    const updateStatus = async (status, rejectionMessage = null) => {
        try {
            const tokenDetailsString = sessionStorage.getItem('userDetails');
            if (tokenDetailsString) {
                const tokenDetails = JSON.parse(tokenDetailsString);
                const token = tokenDetails.idToken;
                const apiClient = new MyApiClient();

                setLoadingShowed(true);
                let saveResult;

                if (props.isSuperAdmin) {
                     const userId = props.userId || (props.profile ? props.profile.id : null);
                     saveResult = await apiClient.updateAdministrationClubInvoiceDataSenderStatus(token, status, userId, rejectionMessage);
                } else {
                    let data_update = {
                        club: {
                            id: props.profile.club.id,
                            invoiceDataSender: {
                                status: status
                            }
                        } 
                    };
                    saveResult = await apiClient.updateProfile(token, data_update);
                }
                
                setLoadingShowed(false);

                if (saveResult && saveResult.error) {
                    setModalTitle("Errore durante l'operazione");
                    setModalText("Si è verificato un errore durante il salvataggio (" + saveResult.error + ")");
                    setReloadOnClose(false);
                    setModalShowed(true);
                } else {
                    setModalTitle("Operazione completata");
                    setModalText("L'operazione è stata completata con successo.");
                    setReloadOnClose(true);
                    setModalShowed(true);
                }
            }
        } catch (error) {
            console.error("Error fetching data:", error);
        }
    }

    const handleActionClick = (status) => {
        setPendingStatus(status);
        setRejectionMessageInput('');
        setShowConfirmModal(true);
    };

    const handleConfirmDisable = () => {
        if (props.isSuperAdmin && pendingStatus === 'REJECTED' && !rejectionMessageInput.trim()) {
            segnalaMancanti([{ campo: 'fat-motivo-rifiuto', messaggio: 'Manca il motivo del rifiuto o della disattivazione' }]);
            return;
        }

        setShowConfirmModal(false);
        if (pendingStatus) {
            updateStatus(pendingStatus, rejectionMessageInput);
            setPendingStatus(null);
            setRejectionMessageInput('');
        } else {
            setBillingEnabled(false);
            performSave(false);
        }
    };

    const handleConfirmSave = () => {
        setShowSaveConfirmModal(false);
        performSave(true);
    };

	const handleSaveClick = (e) => {
		e.preventDefault();

		const form = formRef.current;
		if (form) {

			if (billingEnabled && props.profile?.club?.profileStatus !== 'COMPLETED') {
				setModalTitle("Profilo struttura incompleto");
				setModalText("Per attivare la generazione dei documenti fiscali devi prima completare il profilo della tua struttura.");
				setReloadOnClose(false);
				setModalShowed(true);
				return;
			}

			if (billingEnabled) {
				const m = [];
				const clubNature = props.profile.club.clubNature;
				if (!formData.ragione_sociale) m.push({ campo: 'fat-ragione_sociale', messaggio: 'Manca la ragione sociale' });
				// SRL / SPA e ATP / STP: regime forzato a RF01 (ordinario), formData.fiscal_regime resta vuoto → non va validato
				if (!formData.fiscal_regime && !haRegimeOrdinario(clubNature)) m.push({ campo: 'fat-fiscal_regime', messaggio: 'Manca il regime fiscale' });
				if ((clubNature === 'ASD' || clubNature === 'SSD') && formData.legge_398_91 === null) m.push({ campo: 'fat-legge_398_91', messaggio: 'Manca la scelta sulla legge 398/91' });
				if (!formData.partita_iva) {
					if (clubNature !== 'ASD') m.push({ campo: 'fat-partita_iva', messaggio: 'Manca la partita IVA' });
				} else if (formData.partita_iva.length !== 11 || isNaN(formData.partita_iva)) {
					m.push({ campo: 'fat-partita_iva', messaggio: `La partita IVA deve avere 11 cifre numeriche: ne hai scritte ${formData.partita_iva.length}` });
				}
				if (!formData.codice_fiscale) {
					m.push({ campo: 'fat-codice_fiscale', messaggio: 'Manca il codice fiscale' });
				} else {
					const cf = formData.codice_fiscale;
					const cfRegex = /^[A-Z]{6}[0-9]{2}[A-Z][0-9]{2}[A-Z][0-9]{3}[A-Z]$/i;
					const cfValido = (cf.length === 16 && cfRegex.test(cf)) || (cf.length === 11 && !isNaN(cf));
					if (!cfValido) m.push({ campo: 'fat-codice_fiscale', messaggio: 'Controlla il formato del codice fiscale (16 caratteri) o della partita IVA (11 cifre)' });
				}
				// La PEC del mittente non serve a emettere fatture elettroniche: nel
				// tracciato FatturaPA il CedentePrestatore non ha un campo PEC, e il
				// provider SDI registra il mittente per partita IVA. Quella che conta
				// e` la PEC del destinatario, chiesta altrove e gia' obbligatoria li`
				// quando manca il codice SDI. Qui resta un recapito facoltativo: si
				// controlla solo che, se scritto, sia scritto bene.
				if (formData.pec && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formData.pec)) {
					m.push({ campo: 'fat-pec', messaggio: 'La PEC non è scritta in modo corretto' });
				}
				if (!formData.indirizzo) m.push({ campo: 'fat-indirizzo', messaggio: "Manca l'indirizzo" });
				if (!formData.cap) {
					m.push({ campo: 'fat-cap', messaggio: 'Manca il CAP' });
				} else if (formData.cap.length !== 5 || isNaN(formData.cap)) {
					m.push({ campo: 'fat-cap', messaggio: 'Il CAP deve avere 5 cifre numeriche' });
				}
				if (!formData.citta) m.push({ campo: 'fat-citta', messaggio: 'Manca la città' });
				if (!formData.provincia) m.push({ campo: 'fat-provincia', messaggio: 'Manca la provincia' });

				if (segnalaMancanti(m) > 0) return;
				setShowSaveConfirmModal(true);
			} else {
				performSave(false);
			}
		}
	};

	useEffect(() => {
	
		if (props.profile && props.profile.club) {
			let structureData = props.profile;

			// Indirizzo della sede legale, usato come fallback quando i campi
			// fiscali sono ancora vuoti (la sede legale può coincidere con quella operativa)
			const legalAddress = structureData.club.legalAddress || {};

			if (structureData && structureData.club && structureData.club.invoiceDataSender) {
				const invoiceData = structureData.club.invoiceDataSender;
				setBillingEnabled(invoiceData.invoice_enabled);
				setInvoiceStatus(invoiceData.status || '');
                setReceivedRejectionMessage(invoiceData.rejectionMessage || '');
				setFormData(prevState => ({
					...prevState,
					ragione_sociale: invoiceData.denomination || structureData.club.name || '',
					partita_iva: invoiceData.vat_number || structureData.club.vatNumber || '',
					fiscal_regime: invoiceData.fiscal_regime,
					vat_section: invoiceData.vat_section,
					codice_fiscale: invoiceData.tax_code || structureData.club.taxCode || '',
					pec: invoiceData.pec || '',
					indirizzo: invoiceData.address || legalAddress.streetAddress || '',
					cap: invoiceData.zip_code || legalAddress.postalCode || '',
					citta: invoiceData.city || legalAddress.locality || '',
					provincia: invoiceData.province || legalAddress.province || '',
					nazione: invoiceData.nation || legalAddress.country || 'Italia',
                    legge_398_91: (structureData.club.legge_398_91 === true || structureData.club.legge_398_91 === false) ? structureData.club.legge_398_91 : null
				}))
			} else {
				// Documenti fiscali ancora non compilati: pre-compila l'indirizzo
				// con quello della sede legale
				setFormData(prevState => ({
					...prevState,
					// Dall'IDS: ragione sociale = nome della struttura, partita IVA e codice fiscale se gia' inseriti
					ragione_sociale: structureData.club.name || '',
					partita_iva: structureData.club.vatNumber || '',
					codice_fiscale: structureData.club.taxCode || '',
					indirizzo: legalAddress.streetAddress || '',
					cap: legalAddress.postalCode || '',
					citta: legalAddress.locality || '',
					provincia: legalAddress.province || '',
					nazione: legalAddress.country || 'Italia',
                    legge_398_91: (structureData.club.legge_398_91 === true || structureData.club.legge_398_91 === false) ? structureData.club.legge_398_91 : null
				}))
			}
		}

	}, [props]);
	
	return (
		<>
			<Modal className="fade" show={loadingShowed} centered>
				<Modal.Body className="text-center">
				<Spinner animation="border" role="status">
					<span className="sr-only">Loading...</span>
				</Spinner>
				<div>Caricamento in corso...</div>
				</Modal.Body>
			</Modal>

			<Modal className="fade" show={modalShowed} centered>
				<Modal.Header>
					<Modal.Title>{modalTitle}</Modal.Title>
					<Button onClick={() => {
						setModalShowed(false);
						if (reloadOnClose) ricaricaQui();
					}} variant="" className="btn-close">
					</Button>
				</Modal.Header>
				<Modal.Body>
					<Row><Col className="col-xl-64">{modalText}</Col></Row>
				</Modal.Body>
				<Modal.Footer className="justify-content-center">
					<Button className="btn btn-primary btn-add" onClick={() => {
						setModalShowed(false);
						if (reloadOnClose) ricaricaQui();
					}}>
						Chiudi
					</Button>
				</Modal.Footer>
			</Modal>

			<Modal className="fade" show={showConfirmModal} centered>
				<Modal.Header>
					<Modal.Title>
						{!props.isSuperAdmin
							? 'Ritirare la richiesta di fatturazione elettronica?'
							: pendingStatus === 'CONFIRMED'
								? 'Confermare la fatturazione elettronica?'
								: invoiceStatus === 'CONFIRMED' ? 'Disabilitare la fatturazione elettronica?' : 'Rifiutare la fatturazione elettronica?'}
					</Modal.Title>
					<Button onClick={() => setShowConfirmModal(false)} variant="" className="btn-close">
					</Button>
				</Modal.Header>
				<Modal.Body>
					<Row><Col className="col-xl-12">
                        {props.isSuperAdmin ? (
                            pendingStatus === 'CONFIRMED' ? (
                                <>
                                    La struttura riceverà una notifica di conferma.
                                </>
                            ) : (
                                <>
                                    La struttura dovrà effettuare una nuova richiesta per riattivarla.
                                    {pendingStatus === 'REJECTED' && " Una e-mail verrà inviata alla struttura per avvisarla della decisione."}
                                    {pendingStatus === 'REJECTED' && (
                                        <div className="mt-3">
                                            <Form.Label htmlFor="fat-motivo-rifiuto">Motivo del rifiuto/disattivazione *</Form.Label>
                                            <Form.Control
                                                id="fat-motivo-rifiuto"
                                                as="textarea"
                                                rows={3}
                                                value={rejectionMessageInput}
                                                onChange={(e) => setRejectionMessageInput(e.target.value)}
                                            />
                                        </div>
                                    )}
                                </>
                            )
                        ) : (
                            <>
                                Disabilitando l'opzione perderai la richiesta di attivazione della fatturazione elettronica attualmente presente.
                                <br/><br/>
                                Sarà necessario effettuare una nuova richiesta in seguito per riattivarla.
                            </>
                        )}
					</Col></Row>
				</Modal.Body>
				<Modal.Footer className="justify-content-center">
					<Button className="btn btn-light btn-add" onClick={() => setShowConfirmModal(false)}>
						Annulla
					</Button>
					<Button className="btn btn-primary btn-add" onClick={handleConfirmDisable}>
						Conferma
					</Button>
				</Modal.Footer>
			</Modal>

			<Modal className="fade" show={showSaveConfirmModal} centered>
				<Modal.Header>
					<Modal.Title>Chiedere l'attivazione della generazione documenti?</Modal.Title>
					<Button onClick={() => setShowSaveConfirmModal(false)} variant="" className="btn-close">
					</Button>
				</Modal.Header>
				<Modal.Body>
					<Row><Col className="col-xl-12">
						Abilitando l'opzione "Generazione documenti", la richiesta verrà inviata all'amministrazione per l'approvazione.
						<br/><br/>
						Verrà inviata una email di notifica all'amministratore.
					</Col></Row>
				</Modal.Body>
				<Modal.Footer className="justify-content-center">
					<Button className="btn btn-light btn-add" onClick={() => setShowSaveConfirmModal(false)}>
						Annulla
					</Button>
					<Button className="btn btn-primary btn-add" onClick={handleConfirmSave}>
						Conferma
					</Button>
				</Modal.Footer>
			</Modal>

			<Row className="align-items-start mt-4">
				<div className="col-xl-9">
					{/*<Card>
						<Card.Header>
							<h4 className="card-title">Generazione automatica XML fatture elettroniche (non invio) e ricevute</h4>
						</Card.Header>
						<Card.Body>
							<div className="text-center py-5">
								<h5 className="text-muted">Funzione in fase di attivazione</h5>
							</div>
						</Card.Body>
					</Card>*/}
					<Card>
						<Card.Header>
							<h4 className="card-title">Generazione ricevute e fatture (con invio al cassetto fiscale)</h4>
						</Card.Header>
						<Card.Body>
							{invoiceStatus === 'WAIT_RESPONSE' && !props.isSuperAdmin && (
								<Alert variant="warning" className='solid' style={{color: 'black'}}>
									<strong>Attenzione!</strong> La tua richiesta di attivazione è in attesa di approvazione da parte dell'amministrazione. Puoi comunque modificare i dati se necessario.
								</Alert>
							)}
							{invoiceStatus === 'REJECTED' && !props.isSuperAdmin && (
								<Alert variant="danger" className='solid'>
									<strong>Attenzione!</strong> La tua richiesta attuale è stata rifiutata, modifica i dati e invia una nuova richiesta per l'approvazione.
                                    {receivedRejectionMessage && (
                                        <div className="mt-2">
                                            <strong>Motivo:</strong> {receivedRejectionMessage}
                                        </div>
                                    )}
								</Alert>
							)}
							{invoiceStatus === 'CONFIRMED' && !props.isSuperAdmin && (
								<Alert variant="success" className='solid'>
									<strong>Ottimo!</strong> La generazione automatica XML fatture elettroniche con invio al cassetto fiscale è attiva.
								</Alert>
							)}
							
							{/* SuperAdmin Alerts */}
							{invoiceStatus === 'WAIT_RESPONSE' && props.isSuperAdmin && (
								<Alert variant="warning" className='solid' style={{color: 'black'}}>
									<strong>In attesa di approvazione</strong> - Richiesta di attivazione della generazione dei documenti fiscali.
								</Alert>
							)}
							{invoiceStatus === 'REJECTED' && props.isSuperAdmin && (
								<Alert variant="danger" className='solid'>
									<strong>Rifiutata</strong> - La richiesta di attivazione della generazione dei documenti fiscali è stata rifiutata.
                                    {receivedRejectionMessage && (
                                        <div className="mt-2">
                                            <strong>Motivo:</strong> {receivedRejectionMessage}
                                        </div>
                                    )}
								</Alert>
							)}
							{invoiceStatus === 'CONFIRMED' && props.isSuperAdmin && (
								<Alert variant="success" className='solid'>
									<strong>Approvata</strong> - La generazione automatica XML fatture elettroniche (con invio al cassetto fiscale) e ricevute è attiva e confermata.
								</Alert>
							)}
							<Form ref={formRef} noValidate>
								<Row>
									<Col className="col-xl-12">
										<Form.Check 
											type="switch"
											id="stripe-switch"
											label="Abilita generazione documenti"
											checked={billingEnabled}
											onChange={handleSwitchChange}
											disabled={props.isSuperAdmin}
											className="sid-switch-grande"
										/>
									</Col>
								</Row>
								{billingEnabled && !props.isSuperAdmin && (invoiceStatus === '' || invoiceStatus === 'REJECTED') && (
									<Alert variant="info" className="mt-4 mb-0" style={{ color: '#1A1A1A' }}>
										<strong>Stai per inviare una richiesta.</strong> I dati che inserisci saranno verificati da SportID: la generazione di ricevute e fatture
										si attiva solo dopo la sua approvazione.
									</Alert>
								)}
								{billingEnabled && (
									<>
										<Row className="mt-4">
											<Col lg={6}>
												<Form.Label htmlFor="fat-ragione_sociale">Ragione sociale</Form.Label>
												<Form.Control
													required
													style={{
														color: (invoiceStatus === 'CONFIRMED' || props.isSuperAdmin) ? 'rgba(108,117,125,0.6)' : '#000000',
														backgroundColor: (invoiceStatus === 'CONFIRMED' || props.isSuperAdmin) ? '#f2f2f2' : '#ffffff',
														fontWeight: "normal",
														paddingLeft: "15px"
													}}
													className="mt-2"
													type="text"
													id="fat-ragione_sociale"
									name="ragione_sociale"
													value={formData.ragione_sociale}
													onChange={e => setFormData(prev => ({ ...prev, ragione_sociale: e.target.value }))}
													disabled={invoiceStatus === 'CONFIRMED' || props.isSuperAdmin}
												/>
											</Col>
											<Col lg={3}>
												<Form.Label htmlFor="fat-fiscal_regime">Regime fiscale *</Form.Label>
												<Select
													required
													className="mt-2"
													inputId="fat-fiscal_regime"
													styles={sidSelectStyles}
									name="fiscal_regime"
													value={fiscalRegime.find(option => option.value === (haRegimeOrdinario(props.profile.club.clubNature) ? 'RF01' : formData.fiscal_regime))}
													onChange={(selectedOption) => handleSelectChange(selectedOption, "fiscal_regime")}
													options={fiscalRegime}
													isDisabled={invoiceStatus === 'CONFIRMED' || props.isSuperAdmin || haRegimeOrdinario(props.profile.club.clubNature)}
												/>
											</Col>
											{(props.profile.club.clubNature === 'ASD' || props.profile.club.clubNature === 'SSD') && (
											<Col lg={3}>
												<Form.Label htmlFor="fat-legge_398_91">Legge 398/91 *</Form.Label>
												<Select
													required
													className="mt-2"
													inputId="fat-legge_398_91"
													styles={sidSelectStyles}
									name="legge_398_91"
													value={optionsLegge398.filter(option => option.value === formData.legge_398_91)}
													onChange={handleSelectLegge398}
													options={optionsLegge398}
													isDisabled={invoiceStatus === 'CONFIRMED' || props.isSuperAdmin}
												/>
											</Col>
											)}
										</Row>
										<Row className="mt-4">
											<Col lg={6}>
												<Form.Label htmlFor="fat-partita_iva">Partita IVA</Form.Label>
												<Form.Control
													required={props.profile.club.clubNature !== 'ASD'}
													style={{
														color: (invoiceStatus === 'CONFIRMED' || props.isSuperAdmin) ? 'rgba(108,117,125,0.6)' : '#000000',
														backgroundColor: (invoiceStatus === 'CONFIRMED' || props.isSuperAdmin) ? '#f2f2f2' : '#ffffff',
														fontWeight: "normal",
														paddingLeft: "15px"
													}}
													className="mt-2"
													type="text"
													id="fat-partita_iva"
									name="partita_iva"
													value={formData.partita_iva}
													onChange={e => setFormData(prev => ({ ...prev, partita_iva: e.target.value }))}
													disabled={invoiceStatus === 'CONFIRMED' || props.isSuperAdmin}
												/>
											</Col>
											<Col lg={6}>
												<Form.Label htmlFor="fat-codice_fiscale">Codice Fiscale</Form.Label>
												<Form.Control
													required
													style={{
														color: (invoiceStatus === 'CONFIRMED' || props.isSuperAdmin) ? 'rgba(108,117,125,0.6)' : '#000000',
														backgroundColor: (invoiceStatus === 'CONFIRMED' || props.isSuperAdmin) ? '#f2f2f2' : '#ffffff',
														fontWeight: "normal",
														paddingLeft: "15px"
													}}
													className="mt-2"
													type="text"
													id="fat-codice_fiscale"
									name="codice_fiscale"
													value={formData.codice_fiscale}
													onChange={e => setFormData(prev => ({ ...prev, codice_fiscale: e.target.value }))}
													disabled={invoiceStatus === 'CONFIRMED' || props.isSuperAdmin}
												/>
											</Col>
										</Row>
										<Row className="mt-4">
											<Col lg={6}>
												<Form.Label htmlFor="fat-pec">PEC (Opzionale)</Form.Label>
												<Form.Control
													style={{
														color: (invoiceStatus === 'CONFIRMED' || props.isSuperAdmin) ? 'rgba(108,117,125,0.6)' : '#000000',
														backgroundColor: (invoiceStatus === 'CONFIRMED' || props.isSuperAdmin) ? '#f2f2f2' : '#ffffff',
														fontWeight: "normal",
														paddingLeft: "15px"
													}}
													className="mt-2"
													type="email"
													id="fat-pec"
									name="pec"
													value={formData.pec}
													onChange={e => setFormData(prev => ({ ...prev, pec: e.target.value }))}
													disabled={invoiceStatus === 'CONFIRMED' || props.isSuperAdmin}
												/>
											</Col>
											<Col lg={6}>
												<Form.Label>Sezionale (Opzionale)</Form.Label>
												<Form.Control
													style={{
														color: (invoiceStatus === 'CONFIRMED' || props.isSuperAdmin) ? 'rgba(108,117,125,0.6)' : '#000000',
														backgroundColor: (invoiceStatus === 'CONFIRMED' || props.isSuperAdmin) ? '#f2f2f2' : '#ffffff',
														fontWeight: "normal",
														paddingLeft: "15px"
													}}
													className="mt-2"
													type="text"
													name="vat_section"
													value={formData.vat_section}
													onChange={e => setFormData(prev => ({ ...prev, vat_section: e.target.value }))}
													disabled={invoiceStatus === 'CONFIRMED' || props.isSuperAdmin}
												/>
											</Col>
										</Row>
										<Row className="mt-4">
											<Col lg={6}>
												<Form.Label htmlFor="fat-indirizzo">Indirizzo</Form.Label>
												<Form.Control
													required
													style={{
														color: (invoiceStatus === 'CONFIRMED' || props.isSuperAdmin) ? 'rgba(108,117,125,0.6)' : '#000000',
														backgroundColor: (invoiceStatus === 'CONFIRMED' || props.isSuperAdmin) ? '#f2f2f2' : '#ffffff',
														fontWeight: "normal",
														paddingLeft: "15px"
													}}
													className="mt-2"
													type="text"
													id="fat-indirizzo"
									name="indirizzo"
													value={formData.indirizzo}
													onChange={e => setFormData(prev => ({ ...prev, indirizzo: e.target.value }))}
													disabled={invoiceStatus === 'CONFIRMED' || props.isSuperAdmin}
												/>
											</Col>
											<Col lg={3}>
												<Form.Label htmlFor="fat-cap">CAP</Form.Label>
												<Form.Control
													required
													style={{
														color: (invoiceStatus === 'CONFIRMED' || props.isSuperAdmin) ? 'rgba(108,117,125,0.6)' : '#000000',
														backgroundColor: (invoiceStatus === 'CONFIRMED' || props.isSuperAdmin) ? '#f2f2f2' : '#ffffff',
														fontWeight: "normal",
														paddingLeft: "15px"
													}}
													className="mt-2"
													type="text"
													id="fat-cap"
									name="cap"
													value={formData.cap}
													onChange={e => setFormData(prev => ({ ...prev, cap: e.target.value }))}
													disabled={invoiceStatus === 'CONFIRMED' || props.isSuperAdmin}
												/>
											</Col>
											<Col lg={3}>
												<Form.Label htmlFor="fat-citta">Città</Form.Label>
												<Form.Control
													required
													style={{
														color: (invoiceStatus === 'CONFIRMED' || props.isSuperAdmin) ? 'rgba(108,117,125,0.6)' : '#000000',
														backgroundColor: (invoiceStatus === 'CONFIRMED' || props.isSuperAdmin) ? '#f2f2f2' : '#ffffff',
														fontWeight: "normal",
														paddingLeft: "15px"
													}}
													className="mt-2"
													type="text"
													id="fat-citta"
									name="citta"
													value={formData.citta}
													onChange={e => setFormData(prev => ({ ...prev, citta: e.target.value }))}
													disabled={invoiceStatus === 'CONFIRMED' || props.isSuperAdmin}
												/>
											</Col>
										</Row>
										<Row className="mt-4">
											<Col lg={6}>
												<Form.Label htmlFor="fat-provincia">Provincia *</Form.Label>
												<Select
													required
													className="mt-2"
													inputId="fat-provincia"
													styles={sidSelectStyles}
									name="provincia"
													value={italianProvinces.find(option => option.value === formData.provincia)}
													onChange={(selectedOption) => handleSelectChange(selectedOption, "provincia")} 
													options={italianProvinces}
													isDisabled={invoiceStatus === 'CONFIRMED' || props.isSuperAdmin}
												/>
											</Col>
											<Col lg={6}>
												<Form.Label>Nazione</Form.Label>
												<Form.Control
													required
													disabled
													style={{color: 'rgba(108,117,125,0.6)', backgroundColor: '#f2f2f2', paddingLeft: "15px", fontWeight: "normal" }}
													className="mt-2"
													type="text"
													name="nazione"
													value="Italia"
													onChange={e => setFormData(prev => ({ ...prev, nazione: e.target.value }))}
												/>
											</Col>
										</Row>
									</>
								)}
							</Form>
						</Card.Body>
					</Card>
									<div className="d-flex justify-content-end gap-4 mt-4">
                                        {!props.isDisabled && invoiceStatus !== 'CONFIRMED' && !props.isSuperAdmin && billingEnabled && (
                                            <Button type="button" onClick={handleSaveClick} className="btn btn-primary btn-add">
                                                {(invoiceStatus === '' || invoiceStatus === 'REJECTED') ? 'Invia richiesta' : 'Salva'}
                                            </Button>
                                        )}
                                        {!props.isDisabled && !props.isSuperAdmin && !billingEnabled && (invoiceStatus === 'REJECTED' || invoiceStatus === 'WAIT_RESPONSE') && (
                                            <Button type="button" onClick={() => setShowConfirmModal(true)} className="btn btn-danger btn-add">Annulla richiesta</Button>
                                        )}
                                        {props.isSuperAdmin && invoiceStatus === 'WAIT_RESPONSE' && (
                                            <>
                                                <Button type="button" onClick={() => handleActionClick('REJECTED')} className="btn btn-danger btn-add">Rifiuta</Button>
                                                <Button type="button" onClick={() => handleActionClick('CONFIRMED')} className="btn btn-success btn-add">Conferma</Button>
                                            </>
                                        )}
                                        {props.isSuperAdmin && invoiceStatus === 'CONFIRMED' && (
                                            <Button type="button" onClick={() => handleActionClick('REJECTED')} className="btn btn-danger btn-add">Disattiva</Button>
                                        )}
                                    </div>
					{/* Numerazione univoca (soci e tessere): compare solo con la generazione dei documenti abilitata, in un riquadro bianco sotto il primo Salva, con il suo Salva dentro */}
					{billingEnabled && props.sottoRiquadro && <div className="mt-4">{props.sottoRiquadro}</div>}
                                </div>
				<div className="col-xl-3">
					<Card>
						<Card.Body className="text-left">
							Abilitando l’opzione "Generazione documenti" nel backend, il sistema gestirà automaticamente la produzione dei documenti fiscali nel momento in cui un cliente effettua un acquisto. Il comportamento varia a seconda della natura giuridica della struttura e del rapporto tra cliente e struttura.
							<br></br><br></br>
							<b>Quando il flag è attivo:</b><br></br>
							<i>ASD / SSD (Associazioni o Società Sportive Dilettantistiche)</i><br></br>
							Se il cliente è un socio oppure è tesserato per lo sport per cui sta acquistando un servizio:
							viene generata una ricevuta (non una fattura).
							In tutti gli altri casi (cliente non socio o non tesserato):
							viene generata e inviata una fattura elettronica.
							<br></br><br></br>
							<i>Altre forme giuridiche (es. SRL, ditta individuale, ecc.)</i><br></br>
							Viene generata e inviata sempre una fattura elettronica, indipendentemente dal tipo di cliente.
							<br></br><br></br>
							<b>Quando il flag è disattivo:</b><br></br>
							Non viene generato alcun documento fiscale in automatico (né fatture, né ricevute).
                            <br></br><br></br>
                            <b>Processo di attivazione:</b><br></br>
                            1. Compila i dati e attiva l'opzione.<br></br>
                            2. La richiesta viene inviata all'amministrazione (Stato: In attesa).<br></br>
                            3. L'amministrazione verifica i dati.<br></br>
                            4. Se approvata, il servizio viene attivato (Stato: Confermato).<br></br>
                            5. Se rifiutata, dovrai correggere i dati e inviare una nuova richiesta.
						</Card.Body>
					</Card>
				</div>
			</Row>
		</>
	)
}
export default FormFatturazione;